<template>
  <div class="main container alert-conatiner">
    <div class="alert alert-soft-primary">
      <div class="d-flex">
        <div class="flex-shrink-0">
          <i class="fas fa-info-circle mr-2" />
        </div>
        <div class="flex-grow-1">
          {{ $t('M08e-02') }}
          <div v-html="$t('M08e-02-02', { url: credentials_url })" />
        </div>
      </div>
    </div>

    <div id="embed-area" />
  </div>
</template>

<script>
// import { getDeveloperCredentialKey } from '@/api/profile'
import apiInfoMixin from '@/mixins/api-info'
import getRuntimeConfig from '@/utils/get-runtime-config'

export default {
  name: 'ApiInfoDemo',
  mixins: [apiInfoMixin],
  props: {
    profileId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      demo_method: '',
      demo_meta: {},
      credentials_url: ''
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  mounted() {
    this.initialise()
  },
  methods: {
    initialise() {
      const apiInfo = this.apiInfo[0]
      this.getCredentialsUrl()

      if (apiInfo) {
        this.demo_method = apiInfo.demo_method
        this.demo_meta = apiInfo.demo_meta

        if (apiInfo) {
          this.demo_method = apiInfo.demo_method
          this.demo_meta = apiInfo.demo_meta
          const scriptBlock = document.createElement('script')

          switch (this.demo_method) {
            case 'jsfiddle':
              scriptBlock.setAttribute('async', true)

              scriptBlock.src = JSON.parse(this.demo_meta).path
              document.body.appendChild(scriptBlock)
              document.querySelector('#embed-area').appendChild(scriptBlock)
              break
          }
        }
      }
    },
    async getCredentialsUrl() {
      const runtimeConfig = await getRuntimeConfig()
      this.credentials_url = `${runtimeConfig.DEVELOPER_PORTAL_URL}/#/credentials`
    }
  }
}
</script>

<style lang="scss" scoped>
.main.container {
  margin: 20px auto;
}

iframe {
  border: 0px;
  margin-top: 10px;
  min-height: 300px;
}

.flex-grow-1 ::v-deep a {
  font-weight: 400 !important;
  text-decoration: underline;
}

.flex-grow-1 ::v-deep a:hover {
  color: #007DBA !important;
}

.alert-container {
  min-height: 30vh;
}
</style>
